module.exports = __webpack_public_path__ + "static/media/addPost.66d62fad.svg";